import { render, staticRenderFns } from "./diseasesInsectPestsDetail.vue?vue&type=template&id=05488748"
import script from "./diseasesInsectPestsDetail.vue?vue&type=script&lang=js"
export * from "./diseasesInsectPestsDetail.vue?vue&type=script&lang=js"
import style0 from "./diseasesInsectPestsDetail.vue?vue&type=style&index=0&id=05488748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports